import { Playground } from 'docz';
import { Form, Field, Button, Select, RadioGroup } from "../../../../../src";
import { Label } from 'styled-base-components';
import { FormGroup, FormControl, FormCheck, FormCheckInput } from 'styled-form-component';
import { Column } from 'styled-grid-system-component';
import { Button as Btn } from 'styled-button-component';
import { MyButton } from "../../../../../docz/style/MyButton";
import { MyInput } from "../../../../../docz/style/MyInput";
import { MyClassNameButton } from "../../../../../docz/style/MyClassNameButton";
import { MyClassNameInput } from "../../../../../docz/style/MyClassNameInput";
import React from 'react';
export default {
  Playground,
  Form,
  Field,
  Button,
  Select,
  RadioGroup,
  Label,
  FormGroup,
  FormControl,
  FormCheck,
  FormCheckInput,
  Column,
  Btn,
  MyButton,
  MyInput,
  MyClassNameButton,
  MyClassNameInput,
  React
};